$(document).on("click", ".product-options", function(event) {
    event.preventDefault();
    $(this).hide();
    $(this).closest('.product-item').find(".product-item-options , .add-to-cart-button").css("display", "")

})


function RerenderCart(item = null) {
     fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
}
$(document).on("click", ".add-to-cart-button", function(event) {
    event.preventDefault();
    var btn = $(this)
    $(this).addClass("btn--loading")
    var form = $(this).closest('.product-item').find("input[name='id'], select[name='id']").val();
    var errorDiv = $(this).closest('.product-item').find(".error-div");
    $(".error-div").html('');
    var ProductDiv = ''
    if ($(this).parents('.empty_cart_dynamic').length == 0) {
        ProductDiv = $(this).closest('.product-item')

    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: form
        },
        dataType: 'json',
        success: function(cart) {
            jQuery('.js-drawer-open-right').click();
            RerenderCart(cart.handle);

        },
        error: function(xhr, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            errorDiv.html("<div class='error-sub-div'> Opps! This item is no more left in stock now.</div>");
        },
        complete: function(cart) {
            btn.removeClass("btn--loading");
        }
    });
});

$(document).on("change", "select[name='id'],select[name='addon-id']", function(event) {
    event.preventDefault();
    var price = $('option:selected', this).attr('data-price');
    var id = $('option:selected', this).val();

    $(this).closest('.product-item').find(".product_price strong").html(price);
    $(this).closest('.product-item').attr("product_id", id);
    $('#CartDrawer-CartErrors').hide();
});
$(document).on("click", ".product-form__submit", function(event) {
  setTimeout(function () {

  var formData = {'items':[]};
  
  var boxes = $('input[name=addon-products]:checked');
if($(".addon-products").prop('checked') == true){
  boxes.each(function(){
    var form = $(this).closest('.product-item').find("input[name='addon-id'], select[name='addon-id']").val();
    var addon_array = {
      'id': form,
      'quantity': 1
    }
    formData.items.push(addon_array);
 
});
fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  $('.addon-products').prop('checked', false);
//   $.each(formData.items, function( index, value ) {
//   $('div[product_id="'+value.id+'"]').remove();
// });
 RerenderCart();
})
.catch((error) => {
  console.error('Error:', error);
});
  }

}, 1000);
});